import { get } from 'lodash';
export const getBpNum = (input, breakpoint) => Number(get(input, breakpoint, get(input, '_', input)));
//# sourceMappingURL=getBpNum.js.map